import React, { Fragment } from 'react';
interface MarqueeProps {
  items?: string[];
}
export function Marquee({
  items = ['STRATEGY', 'BRANDING', 'SOCIAL', 'CONTENT', 'WEB']
}: MarqueeProps) {
  const loop = [...items, ...items];
  return <div className="bg-brand-black text-brand-white border-y-2 border-brand-black py-[22px] overflow-hidden" data-id="element-158" data-mp="2ikp4x51hjinw">
      <div className="flex gap-[60px] animate-marquee whitespace-nowrap pl-[60px]" data-id="element-159" data-mp="2dm5lbbad6iyp">
        {loop.map((item, i) => <Fragment key={`${item}-${i}`} data-id="element-160" data-mp="3b68me4colebb" data-mpi={i}>
            <span className="font-black text-[clamp(2rem,5vw,3.6rem)] tracking-[0.01em] uppercase" data-id="element-161" data-mp="368qduf2kt13u">
              {item}
            </span>
            <span className="text-brand-accent font-black text-[clamp(2rem,5vw,3.6rem)]" data-id="element-162" data-mp="318kfkg1swgcs">
              ●
            </span>
          </Fragment>)}
      </div>
    </div>;
}